import React, { createContext, Component } from 'react';
// No balance anymore; premium plan only

// Create the context
export const AppContext = createContext();

// Create the provider component
export class AppProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
    // plan data can be added later if needed
    currentProject: null,
    isWriterMode: false,
    // cache of project types by id
    projectTypes: {},
    currentProjectType: null,
    // chapters cache by project id and current selection convenience
    chaptersByProject: {},
    currentChapters: null,
    // chapter summaries by project id: { projectId: [{ chapterId, summary, model, provider }] }
    chapterSummariesByProject: {},
    currentChapterSummaries: null,
    };
  }

  // No coin operations; reserved for future plan context

  setCurrentProject = (project) => {
    this.setState((prev) => {
      const next = { ...prev, currentProject: project || null };
      const typeId = project?.project_type_key;
      if (typeId && prev.projectTypes[typeId]) {
        next.currentProjectType = prev.projectTypes[typeId];
      } else {
        next.currentProjectType = null;
      }
      const pid = project?.id;
      if (pid && prev.chaptersByProject[pid]) {
        next.currentChapters = prev.chaptersByProject[pid];
      } else {
        next.currentChapters = null;
      }
      return next;
    });
  };

  clearCurrentProject = () => {
    this.setState({ currentProject: null, currentProjectType: null, currentChapters: null });
  };

  setWriterMode = (isWriterMode) => {
    this.setState({ isWriterMode: !!isWriterMode });
  };

  clearWriterMode = () => {
    this.setState({ isWriterMode: false });
  };

  setProjectType = (projectType) => {
    const id = projectType?.id || projectType?.key || projectType?.uuid;
    if (!id) return;
    this.setState((prev) => {
      const projectTypes = { ...prev.projectTypes, [id]: projectType };
      const next = { ...prev, projectTypes };
      if (prev.currentProject?.project_type_key === id) {
        next.currentProjectType = projectType;
      }
      return next;
    });
  };

  clearProjectTypes = () => {
    this.setState({ projectTypes: {}, currentProjectType: null });
  };

  setCurrentProjectType = (projectType) => {
    const id = projectType?.id || projectType?.key || projectType?.uuid;
    if (!id) return;
    this.setState((prev) => ({
      ...prev,
      currentProjectType: projectType,
      projectTypes: { ...prev.projectTypes, [id]: projectType },
    }));
  };

  setChapters = (projectId, chapters) => {
    if (!projectId) return;
    this.setState((prev) => {
      const list = Array.isArray(chapters) ? chapters : [];
      const chaptersByProject = { ...prev.chaptersByProject, [projectId]: list };
      const next = { ...prev, chaptersByProject };
      if (prev.currentProject?.id === projectId) {
        next.currentChapters = list;
      }
      return next;
    });
  };

  clearChapters = (projectId) => {
    if (!projectId) {
      this.setState({ chaptersByProject: {}, currentChapters: null });
      return;
    }
    this.setState((prev) => {
      const copy = { ...prev.chaptersByProject };
      delete copy[projectId];
      const next = { ...prev, chaptersByProject: copy };
      if (prev.currentProject?.id === projectId) next.currentChapters = null;
      return next;
    });
  };

  setChapterSummaries = (projectId, summaries) => {
    if (!projectId) return;
    this.setState((prev) => {
      const list = Array.isArray(summaries) ? summaries : [];
      const chapterSummariesByProject = { ...prev.chapterSummariesByProject, [projectId]: list };
      const next = { ...prev, chapterSummariesByProject };
      if (prev.currentProject?.id === projectId) {
        next.currentChapterSummaries = list;
      }
      return next;
    });
  };

  clearChapterSummaries = (projectId) => {
    if (!projectId) {
      this.setState({ chapterSummariesByProject: {}, currentChapterSummaries: null });
      return;
    }
    this.setState((prev) => {
      const copy = { ...prev.chapterSummariesByProject };
      delete copy[projectId];
      const next = { ...prev, chapterSummariesByProject: copy };
      if (prev.currentProject?.id === projectId) next.currentChapterSummaries = null;
      return next;
    });
  };

  render() {
    return (
      <AppContext.Provider
        value={{
          state: this.state,
          setCurrentProject: this.setCurrentProject,
          clearCurrentProject: this.clearCurrentProject,
          setProjectType: this.setProjectType,
          clearProjectTypes: this.clearProjectTypes,
          setCurrentProjectType: this.setCurrentProjectType,
          setWriterMode: this.setWriterMode,
          clearWriterMode: this.clearWriterMode,
          setChapters: this.setChapters,
          clearChapters: this.clearChapters,
          setChapterSummaries: this.setChapterSummaries,
          clearChapterSummaries: this.clearChapterSummaries,
          // plan helpers can be added here
        }}
      >
        {this.props.children}
      </AppContext.Provider>
    );
  }
}
